// src/data/condominiosData.js
export const condominiosMock = [
  {
    id: 1,
    nmCondominio: "Condomínio Residencial Parque das Flores",
    nmFantasia: "Parque das Flores",
    cnpj: "12.345.678/0001-90",
    email: "contato@parquedasflores.com.br",
    telefone: "(11) 3456-7890",
    celular: "(11) 99876-5432",
    dtCadastro: "2024-01-15",
    inativo: false,
    inscEstadual: "123.456.789.000",
    contato: "Carlos Mendes",
    site: "www.parquedasflores.com.br",
    tpCondominio: "Residencial",
    tpJuro: "Mensal",
    juroDia: "1.00",
    tpMulta: "percentual",
    multaPerc: "2.00",
    diaVencimento: "10",
    tpFundoReserva: "Percentual",
    vlrFundoReserva: "5.00",
    cobCondominio: "rateioContas",
    vlrCondominio: "0.00",
    cep: "01310-100",
    cidade: "São Paulo",
    uf: "SP",
    bairro: "Jardim Paulista",
    logradouro: "Avenida Paulista",
    numero: "1500",
    complemento: "Bloco A"
  },
  {
    id: 2,
    nmCondominio: "Edifício Comercial Torre Empresarial",
    nmFantasia: "Torre Empresarial",
    cnpj: "98.765.432/0001-10",
    email: "adm@torreempresarial.com.br",
    telefone: "(21) 2233-4455",
    celular: "(21) 98765-4321",
    dtCadastro: "2024-03-22",
    inativo: false,
    inscEstadual: "987.654.321.000",
    contato: "Ana Paula Souza",
    site: "www.torreempresarial.com.br",
    tpCondominio: "Comercial",
    tpJuro: "Diario",
    juroDia: "0.033",
    tpMulta: "vlrFixo",
    multaPerc: "50.00",
    diaVencimento: "5",
    tpFundoReserva: "valorFixo",
    vlrFundoReserva: "500.00",
    cobCondominio: "vlrFixo",
    vlrCondominio: "800.00",
    cep: "20040-020",
    cidade: "Rio de Janeiro",
    uf: "RJ",
    bairro: "Centro",
    logradouro: "Avenida Rio Branco",
    numero: "200",
    complemento: "Sala 1501"
  },
  {
    id: 3,
    nmCondominio: "Residencial Alto das Palmeiras",
    nmFantasia: "Alto das Palmeiras",
    cnpj: "45.678.901/0001-23",
    email: "sindico@altodaspalmeiras.com.br",
    telefone: "(31) 3344-5566",
    celular: "(31) 97654-3210",
    dtCadastro: "2023-11-08",
    inativo: true,
    inscEstadual: "456.789.012.000",
    contato: "Roberto Lima",
    site: "",
    tpCondominio: "Apartamentos",
    tpJuro: "Mensal",
    juroDia: "1.00",
    tpMulta: "percentual",
    multaPerc: "2.00",
    diaVencimento: "15",
    tpFundoReserva: "Percentual",
    vlrFundoReserva: "10.00",
    cobCondominio: "vlrFixo",
    vlrCondominio: "650.00",
    cep: "30140-110",
    cidade: "Belo Horizonte",
    uf: "MG",
    bairro: "Savassi",
    logradouro: "Rua Fernandes Tourinho",
    numero: "350",
    complemento: ""
  },
  {
    id: 4,
    nmCondominio: "Shopping Center Lojas do Norte",
    nmFantasia: "Lojas do Norte",
    cnpj: "67.890.123/0001-45",
    email: "gestao@lojasnorte.com.br",
    telefone: "(85) 3322-1100",
    celular: "(85) 99123-4567",
    dtCadastro: "2024-06-01",
    inativo: false,
    inscEstadual: "678.901.234.000",
    contato: "Fernanda Castro",
    site: "www.lojasnorte.com.br",
    tpCondominio: "Lojas",
    tpJuro: "Diario",
    juroDia: "0.066",
    tpMulta: "vlrFixo",
    multaPerc: "100.00",
    diaVencimento: "1",
    tpFundoReserva: "valorFixo",
    vlrFundoReserva: "1000.00",
    cobCondominio: "vlrFixo",
    vlrCondominio: "1200.00",
    cep: "60160-230",
    cidade: "Fortaleza",
    uf: "CE",
    bairro: "Aldeota",
    logradouro: "Avenida Santos Dumont",
    numero: "2828",
    complemento: "Loja 42"
  },
  {
    id: 5,
    nmCondominio: "Loteamento Vale Verde",
    nmFantasia: "Vale Verde",
    cnpj: "11.222.333/0001-44",
    email: "adm@valeverde.com.br",
    telefone: "(41) 3344-6677",
    celular: "(41) 98877-6655",
    dtCadastro: "2024-08-14",
    inativo: false,
    inscEstadual: "",
    contato: "Marcos Oliveira",
    site: "www.valeverde.com.br",
    tpCondominio: "Lotes",
    tpJuro: "Mensal",
    juroDia: "1.00",
    tpMulta: "percentual",
    multaPerc: "2.00",
    diaVencimento: "20",
    tpFundoReserva: "Percentual",
    vlrFundoReserva: "3.00",
    cobCondominio: "rateioContas",
    vlrCondominio: "0.00",
    cep: "80045-200",
    cidade: "Curitiba",
    uf: "PR",
    bairro: "Batel",
    logradouro: "Rua Comendador Araújo",
    numero: "650",
    complemento: "Quadra 3"
  }
];

export const estadosBR = [
  "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG",
  "PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"
];

export const tiposCondominio = ["Residencial","Comercial","Misto","Apartamentos","Lojas","Lotes"];

export const emptyCondominio = {
  nmCondominio: "",
  nmFantasia: "",
  cnpj: "",
  email: "",
  telefone: "",
  celular: "",
  dtCadastro: new Date().toISOString().split("T")[0],
  inativo: false,
  inscEstadual: "",
  contato: "",
  site: "",
  tpCondominio: "Residencial",
  tpJuro: "Mensal",
  juroDia: "1.00",
  tpMulta: "percentual",
  multaPerc: "2.00",
  diaVencimento: "10",
  tpFundoReserva: "Percentual",
  vlrFundoReserva: "5.00",
  cobCondominio: "rateioContas",
  vlrCondominio: "0.00",
  cep: "",
  cidade: "",
  uf: "SP",
  bairro: "",
  logradouro: "",
  numero: "",
  complemento: ""
};
